// @flow
import React from "react";
import { Form } from "semantic-ui-react";
import { Field } from "redux-form";
import classnames from "classnames";
import type { FieldProps } from "redux-form";
import Styles from "../../ChangeServices/submodules/Old_Edit/components/Customer/SharedStyles.module.scss";
import FormLabelWithDivider from "Commons/Components/FormComponents/components/FormLabelWithDivider";
import Options from "../../../../Commons/Components/FormComponents/components/AddressForm/Options";
import { isRequired } from "../../ChangeServices/submodules/Old_Edit/misc/Validators";

type Props = {
  fields: Dict,
  t: typeof TFunction,
  mobileChangeService?: boolean,
  noLabel?: boolean,
  width?: number,
  divider?: boolean,
};
export const SalutationFields = ({ fields, t, mobileChangeService, noLabel, width = 5, divider }: Props) => {
  return (
    <Form.Group id={Styles["inline"]}>
      {!noLabel && (
        <FormLabelWithDivider
          divider={divider}
          title={t("common:salutationAndTitle")}
          inline
          tooltip={t("mobile.customer.addressDetails.salutationInfo")}
          secondary
        />
      )}

      <Field
        name={fields.salutation}
        component={(props) => {
          return (
            <Form.Dropdown
              id={fields.salutation}
              selection
              search
              error={(props.meta.touched || props.meta.initial === null) && props.meta.error}
              fluid
              width={width}
              className={classnames({
                [Styles.five]: mobileChangeService,
              })}
              placeholder={t("common:salutation.label")}
              options={Options.salutation}
              value={props.input.value}
              onChange={(event, data) => props.input.onChange(data.value)}
            />
          );
        }}
        validate={[isRequired]}
      />
      <Field
        name={fields.salutationTitle}
        component={(props: FieldProps) => {
          return (
            <Form.Dropdown
              id={fields.salutationTitle}
              selection
              search
              fluid
              width={width}
              className={classnames({
                [Styles.five]: mobileChangeService,
              })}
              placeholder={t("common:salutationTitle.label")}
              options={Options.salutationTitle}
              value={props.input.value}
              onChange={(event, data) => props.input.onChange(data.value)}
            />
          );
        }}
      />
    </Form.Group>
  );
};
